import { Component, Input } from '@angular/core';
import { StatusLabelEnum } from 'src/app/components/status-label/status-label.component';

@Component({
  selector: 'app-possible-na-status-cell',
  templateUrl: './possible-na-status-cell.component.html',
  styleUrls: ['./possible-na-status-cell.component.scss'],
})
export class PossibleNaStatusCellComponent {
  @Input() public statusLabel: string;
  @Input() public toolTip: string;

  public get isNotAvailable(): boolean {
    return !this.statusLabel || !Object.values(StatusLabelEnum).includes(this.statusLabel as StatusLabelEnum);
  }
}
